import React from "react";
import { Button, StandardProps, Theme } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";
import clsx from "clsx";
import { StyleClassKey } from "js/react/typescript";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) => ({
    whiteBtn: {
        padding: theme.spacing(0.5, 1.5),
        background: theme.palette.common.white,
        color: theme.palette.primary.main
    },
    darkBtn: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        "&:hover": {
            color: theme.palette.primary.main,
            background: theme.palette.common.white,
            border: `1px solid ${theme.palette.primary.main}`
        }
    },
    whiteDarkBtn: {
        background: theme.palette.common.white,
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        "&:hover": {
            color: theme.palette.common.white,
            background: theme.palette.primary.main
        }
    }
}));

export type AppButtonClassKey = StyleClassKey<typeof useStyles>;

export interface AppButtonProps
    extends StandardProps<ButtonProps, AppButtonClassKey> {
    buttonVariant?: "white" | "dark" | "white-dark";
}

function Component(props: AppButtonProps) {
    const classes = useStyles(props);
    const { className, buttonVariant, ...rest } = props;

    return (
        <Button
            {...rest}
            className={clsx(className, {
                [classes.whiteBtn]: buttonVariant === "white",
                [classes.darkBtn]: buttonVariant === "dark",
                [classes.whiteDarkBtn]: buttonVariant === "white-dark"
            })}
        />
    );
}

Component.displayName = "AppButton";

Component.defaultProps = {
    color: "primary",
    variant: "contained"
} as AppButtonProps;

export const AppButton = Component;
export default AppButton;
